"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const kendo_react_inputs_1 = require("@progress/kendo-react-inputs");
const input_style_1 = __importDefault(require("./input.style"));
const ColorPaletteComponent = (_a) => {
    var { errorMessage, valid } = _a, props = __rest(_a, ["errorMessage", "valid"]);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ style: input_style_1.default.colorPaletteWrapper }, { children: (0, jsx_runtime_1.jsx)(kendo_react_inputs_1.ColorPalette, Object.assign({}, props)) })), !valid && ((0, jsx_runtime_1.jsx)("small", Object.assign({ hidden: valid, className: 'error-label' }, { children: errorMessage })))] }));
};
exports.default = ColorPaletteComponent;
